import styled, { keyframes } from 'styled-components';
import imgBg from '../assets/imgs-background/background1.png';

export const rotateAnimation = keyframes`
from {
  transform: rotate(0deg);
}
to {
  transform: rotate(360deg);
}
`;
export const reverseRotation = keyframes`
from {
  transform: rotate(360deg);
}
to {
  transform: rotate(0deg);
}
`;

export const TanqueStyled = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25%;
  min-height: 100vh;
  min-height: 100vh;
  width: 100%;
  background-image: url(${imgBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  .desativado {
    opacity: 40%;
    cursor: no-drop;
  }
  .sectionTanque {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* justify-content: center; */
    gap: 25%;
    width: 94%;
    height: fit-content;
    min-height: 95vh;
    margin-left: 60px;
    margin-top: 20px;

    background-color: rgba(0, 0, 0, 0.41);
    margin-bottom: 50px;
    border-radius: 5px;
    .avisos {
      display: none;
      position: absolute;
      top: 30px;
      right: 30px;
      font-size: 40px;
      color: rgba(126, 124, 125, 1);
      background: transparent;
      border: 0;
      cursor: pointer;
      transition: 0.5s;
      z-index: 2;
    }
    .avisos:hover {
      color: rgba(180, 180, 180, 1);
    }
    .containerSuperior {
      display: flex;
      width: 100%;
      padding: 10px;
      height: 50vh;
      max-height: 50vh;
      position: relative;
      .close {
        position: absolute;
        top: 10px;
        font-size: 35px;
        left: 66%;
        color: rgba(143, 143, 143, 0.8);
        cursor: pointer;
        transition: 0.5s;
        z-index: 10;
      }
      .close:hover {
        color: rgba(193, 193, 193, 0.8);
      }
      .graficos {
        width: 70%;
        /* height: 100%; */
        border-bottom: 2px solid rgba(165, 165, 165, 0.8);
        border-right: 2px solid rgba(165, 165, 165, 0.8);
      }
      .containerAlertas {
        width: 30%;
        /* height: 100%; */
        max-height: 50vh;
        /* overflow: auto; */
        border-bottom: 2px solid rgba(165, 165, 165, 0.8);
        position: relative;
        .alertas {
          width: 100%;
          height: 50%;
          max-height: 60%;
          color: rgba(187, 187, 187, 0.8);
          h4 {
            display: flex;
            justify-content: center;
            width: 100%;
            align-items: center;
            margin-top: 10px;
            font-size: 22px;
            color: rgba(170, 170, 170, 1);
          }

          div {
            width: 100%;
            height: 100%;
            max-height: 100%;
            flex-grow: 1; /* Faz com que o div ocupe todo o espaço disponível na altura */
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding: 15px;
            overflow-y: auto; /* Adicionado para habilitar a rolagem vertical se o conteúdo for maior do que o espaço disponível */
            span {
              border-bottom: 2px solid rgba(109, 109, 109, 0.74);
            }
          }
        }
        .buttons {
          width: 100%;
          height: 45%;
          max-height: 50%;
          display: flex;
          flex-direction: column;
          justify-content: end;
          padding: 5px;
          gap: 10px;
          max-height: 100%;
          button {
            height: 60px;
            font-size: 20px;
            font-weight: 600;
            max-height: 100%;
            background-color: var(--bgBotao);
            color: var(--bgBranco);
            border-radius: 10px;
            border: 2px solid rgba(0, 0, 0, 0);
          }
          .btnStatus {
            cursor: pointer;
          }
          .btnStatus:hover {
            border: 2px solid var(--bgBranco);
          }
        }
      }

      /* Resumo minimalista dos alertas */
      .containerAlertas {
        min-width: 0;
        padding: 14px 16px 10px;

        .alertas {
          width: 100%;
          height: 100%;
          max-height: none;
          display: flex;
          flex-direction: column;
          color: #eef3f4;

          .alertasCabecalho {
            width: 100%;
            height: auto;
            max-height: none;
            flex: 0 0 auto;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            padding: 0 0 10px;
            overflow: visible;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);

            > div {
              width: auto;
              height: auto;
              min-width: 0;
              display: block;
              padding: 0;
              overflow: visible;
            }

            .alertasContexto {
              display: block;
              margin-bottom: 2px;
              color: #8f9da2;
              font-size: 11px;
              font-weight: 700;
              letter-spacing: 0.11em;
              text-transform: uppercase;
              border: 0;
            }

            h4 {
              display: block;
              width: auto;
              margin: 0;
              color: #f3f6f7;
              font-size: clamp(17px, 1.2vw, 21px);
              line-height: 1.1;
            }

            .alertasQuantidade {
              display: inline-flex;
              align-items: center;
              gap: 6px;
              min-height: 34px;
              padding: 6px 11px;
              color: #c8d1d4;
              background: rgba(255, 255, 255, 0.07);
              border: 1px solid rgba(255, 255, 255, 0.1);
              border-radius: 999px;
              font-family: inherit;
              font-size: 13px;
              cursor: pointer;
              transition:
                color 160ms ease,
                background 160ms ease,
                border-color 160ms ease;

              svg {
                font-size: 17px;
              }

              &:hover,
              &:focus-visible {
                color: #ffffff;
                background: rgba(255, 255, 255, 0.13);
                border-color: rgba(255, 255, 255, 0.24);
                outline: none;
              }
            }
          }

          .alertasResumo {
            width: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;
            min-height: 0;
            padding: 6px 0;
            overflow: hidden;

            li {
              min-height: 0;
              border-bottom: 1px solid rgba(255, 255, 255, 0.08);

              &:last-child {
                border-bottom: 0;
              }

              > button {
                width: 100%;
                display: grid;
                grid-template-columns: 8px minmax(0, 1fr) auto;
                align-items: center;
                gap: 10px;
                padding: 8px 3px;
                color: inherit;
                text-align: left;
                background: transparent;
                border: 0;
                border-radius: 7px;
                cursor: pointer;
                transition: background 160ms ease;

                &:hover {
                  background: rgba(255, 255, 255, 0.055);
                }
              }
            }

            .alertaIndicador {
              width: 7px;
              height: 7px;
              border: 0;
              border-radius: 50%;
              background: #60a5fa;
              box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.1);

              &.critico {
                background: #ff6b6b;
                box-shadow: 0 0 0 4px rgba(255, 107, 107, 0.12);
              }

              &.atencao {
                background: #fbbf24;
                box-shadow: 0 0 0 4px rgba(251, 191, 36, 0.12);
              }
            }

            .alertaConteudo {
              min-width: 0;
              border: 0;

              strong,
              small {
                display: block;
              }

              strong {
                overflow: hidden;
                color: #e6ecee;
                font-size: clamp(12px, 0.82vw, 14px);
                font-weight: 600;
                line-height: 1.25;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              small {
                margin-top: 2px;
                color: #829196;
                font-size: 11px;
              }
            }

            time {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              color: #829196;
              font-size: 10px;
              line-height: 1.2;

              strong {
                color: #bdc8cb;
                font-size: 12px;
              }
            }

            .alertasVazio {
              display: grid;
              flex: 1;
              place-items: center;
              color: #8f9da2;
              font-size: 13px;
            }
          }

          .alertasAcoes {
            width: 100%;
            height: auto;
            max-height: none;
            flex: 0 0 auto;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            padding: 8px 0 0;
            overflow: visible;
            border-top: 1px solid rgba(255, 255, 255, 0.1);

            button {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              gap: 4px;
              padding: 7px 10px;
              color: #d9e1e3;
              background: rgba(255, 255, 255, 0.07);
              border: 1px solid rgba(255, 255, 255, 0.12);
              border-radius: 7px;
              font: inherit;
              font-size: 12px;
              font-weight: 700;
              cursor: pointer;
              transition:
                background 160ms ease,
                border-color 160ms ease;

              &:hover {
                background: rgba(255, 255, 255, 0.12);
                border-color: rgba(255, 255, 255, 0.22);
              }
            }

            .acaoSecundaria {
              color: #9eabad;
              background: transparent;
              border-color: transparent;
            }

            .botaoHistorico {
              min-width: 160px;
              min-height: 42px;
              padding: 10px 16px;
              font-size: 14px;
            }
          }
        }
      }
    }
    .containerInferior {
      width: 100%;
      padding: 15px;
      ul {
        width: 100%;
        display: flex;
        justify-content: center;
        /* align-items: center; */
        gap: 10px;
        list-style: none;
        flex-wrap: wrap;
        li {
          display: flex;
          gap: 15px;
          align-items: center;
          max-width: 100%;
          h3 {
            border: 2px solid rgba(78, 78, 78, 1);
            background-color: rgba(195, 195, 195, 0.8);
            color: rgb(29, 29, 29);
            padding: 10px;
            border-radius: 5px;
            cursor: pointer;
          }
          display: flex;
          flex-direction: column;
          .containerInfos {
            position: relative;
            .ping {
              /* width: 50px;
              height: 50px; */
              position: absolute;
              top: -15px;
              right: 30px;
              display: none;
              button {
                padding: 2px 4px;
                border-radius: 5px;
                cursor: pointer;
                border: 2px solid rgba(104, 104, 104, 0.71);
                background-color: rgba(197, 197, 197, 0.88);
              }
            }

            .gtwStatus {
              position: absolute;
              top: -15px;
              right: 15px;
              font-size: 19px;
              color: rgb(255, 255, 255);
              background-color: rgba(0, 0, 0, 0.6);
              border-radius: 50%;
              border: 1px solid rgba(197, 197, 197, 0.71);
            }
            .gtwStatus:hover + .ping {
              display: flex;
            }
            .ping:hover {
              display: flex;
            }
            .PingGTWOFF {
              opacity: 30%;
            }
            .gtwStatusON {
              color: rgb(3, 219, 10);
            }
            .gtwStatusOFF {
              color: rgb(246, 22, 22);
            }
            .tanqueOn {
              display: flex;
              width: 17px;
              height: 17px;
              border-radius: 50%;
              background-color: rgb(3, 140, 8);
              border: 1px solid rgb(197, 197, 197);
              position: absolute;
              right: -6px;
              top: -6px;
            }
            .tanqueOff {
              display: flex;
              width: 17px;
              height: 17px;
              border-radius: 50%;
              background-color: rgb(201, 0, 0);
              border: 1px solid rgb(197, 197, 197);
              position: absolute;
              right: -6px;
              top: -6px;
            }
            display: flex;
            gap: 20px;

            max-width: 100%;
            background: rgba(0, 0, 0, 0.5);
            background: -moz-linear-gradient(
              0deg,
              rgba(140, 140, 140, 0.6) 0%,
              rgba(237, 237, 237, 0.6) 100%
            );
            background: -webkit-linear-gradient(
              0deg,
              rgba(140, 140, 140, 0.6) 0%,
              rgba(237, 237, 237, 0.6) 100%
            );
            background: linear-gradient(
              0deg,
              rgba(140, 140, 140, 0.6) 0%,
              rgba(237, 237, 237, 0.6) 100%
            );

            padding: 10px;
            padding-bottom: 6px;
            border: 2px solid rgba(57, 57, 57, 1);
            border-radius: 4px;
            align-items: center;
            min-width: 420px;
            min-height: 275px;
            background: red;
            .conteinerLimite {
              display: flex;
              width: 100%;
              justify-content: center;
              align-items: center;
            }
          }
          .infos {
            display: flex;
            flex-direction: column;
            gap: 10px;
            align-items: center;
            justify-content: flex-start;
            min-height: 80px;
            position: relative;
            margin-right: 50px;
            min-height: 190px;

            .barraNivelVerticalWrapper {
              height: 200px;
              width: 55px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              gap: 6px;
              font-size: 11px;
              color: #555;
              position: absolute;
              top: -18px;
              right: -50px;

              span {
                color: #000000;
              }
            }

            .barraNivelVertical {
              position: relative;
              width: 22px;
              height: 200px;
              border-radius: 999px;
              background: #e5e5e5;
              border: 1px solid #ccc;
              overflow: hidden;
            }

            .barraNivelVerticalAtual {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: var(--nivel);
              border-radius: 999px;

              background: linear-gradient(
                to top,
                #19c85f 0%,
                #19c85f 35%,

                #d6d600 45%,
                #ffb000 70%,

                #ff7a00 80%,
                #e60000 100%
              );

              background-size: 100% 165px;
              background-position: bottom;

              transition: height 0.4s ease;
            }
            .info {
              width: 100%;
              display: flex;
              justify-content: space-between;
              gap: 10px;
              font-weight: 600;
              font-size: 18px;

              p {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 17px;
                text-align: center;
                width: 100%;
              }
              span {
                background: rgba(218, 218, 218, 1);
                padding: 2px;
                border: 1px solid rgba(47, 47, 47, 1);
                border-radius: 5px;
                font-size: 16px;
                width: 100px;
                text-align: center;
              }
            }
          }

          .info {
            width: 100%;
            display: flex;
            justify-content: center;
            gap: 10px;
            font-weight: 600;
            font-size: 18px;

            p {
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 17px;
              text-align: center;
              width: 100%;
            }
            span {
              background: rgba(218, 218, 218, 1);
              padding: 2px;
              border: 1px solid rgba(47, 47, 47, 1);
              border-radius: 5px;
              font-size: 16px;
              width: 100px;
              text-align: center;
            }
          }
          .conteinerStatus {
            display: flex;
            flex-direction: column;
            min-height: 225px;
            /* background-color: #00000077; */

            .status {
              display: flex;
              align-items: center;
              flex-direction: column;
              align-items: center;
              height: 100%;
              gap: 10px;
              font-weight: 600;
              .controle {
                display: flex;
                justify-content: space-around;
                width: 100%;

                .divControler {
                  display: flex;
                  gap: 5px;
                  align-items: center;
                  flex-direction: column;
                  justify-content: center;
                  p {
                    font-size: 15px;
                  }
                }
                border-bottom: 2px solid rgba(47, 47, 47, 0.62);
              }
              .Bombas {
                display: flex;
                flex-direction: column;
                gap: 5px;

                span {
                  text-align: center;
                  /* background: rgba(218, 218, 218, 1); */
                  /* padding: 5px 25px; */
                  /* border: 1px solid rgba(47, 47, 47, 1); */
                  /* border-radius: 5px; */

                  /* border-top: 2px solid rgba(47, 47, 47, 0.62); */
                  padding-top: 5px;
                  font-weight: 600;
                  max-width: 200px;
                }
                button {
                  display: flex;
                  align-items: end;
                  justify-content: center;
                  gap: 5px;
                  background-color: rgba(69, 71, 70, 0.1);
                  border: 1px solid rgba(47, 47, 47, 1);
                  border-radius: 10px;
                  padding: 5px 25px;
                  font-weight: 600;
                  color: rgba(36, 36, 36, 1);
                  cursor: pointer;
                  font-weight: 600;
                  .icon {
                    font-size: 16px;
                  }

                  .IconeOn {
                    /* background-color: gray; */
                    text-shadow: 2px 2px 10px rgb(255, 64, 6);
                    /* -webkit-box-shadow: inset 0px 0px 50px 0px #000000;
                    box-shadow: inset 0px 0px 50px 0px rgba(0, 255, 106, 0.14); */
                    border-radius: 50%;
                    filter: drop-shadow(0px 0px 2px rgba(48, 223, 9, 0.6));
                  }
                }
                .btndesativado {
                  opacity: 0.5;
                }
                .butonOff {
                  cursor: not-allowed;
                  opacity: 40%;
                  animation: ${rotateAnimation} 2s linear infinite;
                }
              }
            }
          }
        }
      }
    }
  }
  @media (max-width: 650px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: end;
    padding: 10px;
    .sectionTanque {
      width: 100%;
      margin-left: 0px;
      margin-top: 5px;

      .avisos {
        display: grid;
        place-items: center;
        top: 72px;
        right: 18px;
        width: 42px;
        height: 42px;
        color: #d8e0e2;
        background: rgba(23, 40, 46, 0.9);
        border: 1px solid rgba(255, 255, 255, 0.12);
        border-radius: 10px;
        font-size: 24px;
      }

      .containerSuperior {
        .graficos {
          width: 100%;
        }
        .containerAlertas {
          display: none;
        }
      }

      .containerInferior {
        ul {
          justify-content: center;
          li {
            .containerInfos {
              justify-content: center;
              min-width: 200px;
              width: 350px;
              max-width: 100%;
              .conteinerLimite {
                align-items: center;
                /* justify-content: center; */
                max-height: min-content;
                gap: 2px;
                width: 100%;
                flex-direction: column;
                /* background-color: #19c85f; */
              }
              .barraNivelVerticalWrapper {
                top: 60px;
                right: -80px;
                height: 200px;
                /* background-color: #12a54a; */
              }
              .infos {
                align-items: center;
                justify-content: center;
                .info {
                  gap: 0px;
                }
              }
              .conteinerStatus {
                align-items: center;
                justify-content: center;
              }
            }
          }
        }
        .containerInfos {
          flex-wrap: wrap;
          .conteinerStatus {
            gap: 20px;
          }
        }
      }
    }
  }

  /* Cartões dos tanques: organização visual sem alterar os controles. */
  .sectionTanque {
    .containerSuperior {
      scroll-margin-top: 12px;
    }

    .containerInferior {
      padding: 22px 20px 28px;

      > ul {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(370px, 1fr));
        align-items: start;
        gap: 16px;

        > li {
          width: 100%;
          gap: 0;
          align-items: stretch;
          overflow: visible;
          border: 1px solid rgba(255, 255, 255, 0.13);
          border-radius: 10px;
          background: rgba(32, 51, 57, 0.74);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
          transition:
            border-color 160ms ease,
            transform 160ms ease,
            box-shadow 160ms ease;

          &:hover {
            border-color: rgba(255, 255, 255, 0.24);
            box-shadow: 0 12px 26px rgba(0, 0, 0, 0.18);
            transform: translateY(-1px);
          }

          .tanqueTitulo {
            width: 100%;
            min-height: 52px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 14px;
            padding: 11px 14px;
            border: 0;
            border-bottom: 1px solid rgba(255, 255, 255, 0.12);
            border-radius: 9px 9px 0 0;
            color: #eef2f3;
            background: rgba(1, 8, 10, 0.32);
            cursor: pointer;
            text-align: left;
            transition: background-color 150ms ease;

            &:hover,
            &:focus-visible {
              background: rgba(39, 63, 70, 0.96);
            }

            &:focus-visible {
              outline: 2px solid rgba(197, 216, 220, 0.88);
              outline-offset: -3px;
            }

            > span {
              font-size: 18px;
              font-weight: 700;
              line-height: 1.15;
            }

            small {
              display: inline-flex;
              align-items: center;
              gap: 3px;
              flex-shrink: 0;
              color: #bdc9cc;
              font-size: 11px;
              font-weight: 600;

              svg {
                font-size: 14px;
              }
            }

            &.tanqueTituloSemHistorico {
              cursor: default;

              &:hover {
                background: rgba(1, 8, 10, 0.32);
              }

              small {
                color: rgba(189, 201, 204, 0.72);
                font-weight: 500;
              }
            }
          }

          .containerInfos {
            display: flex;
            justify-content: center;
            align-items: flex-start;
            width: 100%;
            min-width: 0;
            min-height: 345px;
            padding: 44px 16px 15px;
            border: 0;
            border-radius: 0 0 9px 9px;
            gap: 0;
            align-items: flex-start;
            background: linear-gradient(
              145deg,
              rgba(218, 220, 220, 0.82) 0%,
              rgba(151, 156, 157, 0.78) 100%
            );

            &::before {
              content: 'DADOS ATUAIS';
              position: absolute;
              top: 18px;
              left: 16px;
              color: rgba(31, 43, 47, 0.68);
              font-size: 10px;
              font-weight: 800;
              letter-spacing: 0.08em;
            }

            > .gtwStatus {
              top: -60px;
              right: 18px;
              z-index: 4;
              font-size: 21px;
            }

            > .ping {
              top: -60px;
              right: 39px;
              z-index: 5;
            }

            > .tanqueOn,
            > .tanqueOff {
              top: -60px;
              right: -8px;
              z-index: 4;
              width: 19px;
              height: 19px;
            }

            .statusComunicacao {
              position: absolute;
              top: 12px;
              right: 14px;
              z-index: 2;
              display: flex;
              align-items: center;
              gap: 7px;
              .gatewayStatus,
              .tanqueStatus {
                position: relative;
                min-height: 25px;
                display: inline-flex;
                align-items: center;
                gap: 5px;
                padding: 4px 7px;
                border: 1px solid rgba(38, 48, 51, 0.22);
                border-radius: 999px;
                color: #273438;
                background: rgba(239, 241, 241, 0.58);
                font-size: 10px;
                font-weight: 700;
                line-height: 1;
              }

              .gatewayStatus {
                cursor: help;
              }

              .gtwStatus {
                position: static;
                border: 0;
                border-radius: 0;
                color: #334348;
                background: transparent;
                font-size: 14px;
              }

              .gtwStatusON,
              .gtwStatusOFF {
                color: #334348;
              }

              i {
                width: 7px;
                height: 7px;
                display: block;
                border: 1px solid rgba(255, 255, 255, 0.72);
                border-radius: 50%;
              }

              .statusOnline {
                background: #12a54a;
                box-shadow: 0 0 0 2px rgba(18, 165, 74, 0.13);
              }

              .statusOffline {
                background: #d43131;
                box-shadow: 0 0 0 2px rgba(212, 49, 49, 0.13);
              }

              .gatewayStatus:hover .ping,
              .gatewayStatus:focus-within .ping,
              .ping:hover {
                display: flex;
              }

              .ping {
                top: 100%;
                right: 0;
                z-index: 5;
                padding-top: 4px;

                button {
                  min-width: 96px;
                  padding: 6px 8px;
                  border: 1px solid rgba(255, 255, 255, 0.18);
                  border-radius: 6px;
                  color: #eef2f3;
                  background: #273b42;
                  font-size: 11px;
                  white-space: nowrap;
                }
              }
            }

            .conteinerLimite {
              /* align-items: flex-start; */
              gap: 18px;
            }

            .infos {
              flex: 1 1 50%;
              min-width: 0;
              min-height: 0;
              margin-right: 38px;
              gap: 7px;
              align-items: stretch;

              .barraNivelVerticalWrapper {
                top: -5px;
                right: -39px;
                width: 32px;
                height: 160px;
                gap: 4px;
                color: #263236;
                font-size: 9px;
              }

              .barraNivelVertical {
                width: 18px;
                height: 144px;
                border-color: rgba(44, 52, 54, 0.25);
              }

              .info {
                min-height: 29px;
                gap: 8px;
                color: #172125;
                font-size: 14px;

                p {
                  justify-content: flex-start;
                  width: auto;
                  min-width: 0;
                  font-size: 14px;
                  text-align: left;
                  white-space: nowrap;
                }

                span {
                  width: auto;
                  min-width: 66px;
                  margin-left: auto;
                  padding: 3px 7px;
                  border-color: rgba(39, 48, 51, 0.45);
                  border-radius: 5px;
                  color: #11191c;
                  background: rgba(242, 243, 243, 0.72);
                  font-size: 14px;
                  line-height: 1.1;
                }
              }
            }

            .conteinerStatus {
              flex: 1 1 44%;
              min-width: 142px;
              min-height: 0;
              padding-left: 14px;
              border-left: 1px solid rgba(43, 51, 54, 0.28);

              &.somenteNivel {
                align-self: stretch;
                display: flex;
                justify-content: center;

                > .status:first-child {
                  width: 100%;
                  justify-content: flex-start;
                }

                > .status:last-child {
                  display: none;
                }

                .modoSomenteNivel {
                  width: 100%;
                  min-height: 112px;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  gap: 5px;
                  padding: 16px 10px;
                  border-top: 1px solid rgba(43, 51, 54, 0.28);
                  color: #263438;
                  text-align: center;

                  strong {
                    font-size: 13px;
                    line-height: 1.3;
                  }

                  span {
                    color: rgba(38, 52, 56, 0.66);
                    font-size: 11px;
                  }
                }
              }

              > .status {
                height: auto;
              }

              .status {
                gap: 7px;
                color: #172125;
                font-size: 14px;

                > div:first-child > p {
                  font-size: 13px;
                  font-weight: 700;
                }

                .controle {
                  padding-bottom: 7px;
                  border-bottom: 1px solid rgba(43, 51, 54, 0.32);

                  .divControler {
                    gap: 3px;

                    p {
                      font-size: 12px;
                    }
                  }
                }

                .Bombas {
                  width: 100%;
                  gap: 6px;
                  padding-top: 7px;
                  border-top: 1px solid rgba(43, 51, 54, 0.22);

                  &:first-child {
                    border-top: 0;
                  }

                  > span {
                    padding-top: 0;
                    color: #1c292d;
                    font-size: 13px;
                  }

                  button {
                    width: 100%;
                    min-height: 32px;
                    align-items: center;
                    padding: 5px 10px;
                    border-color: rgba(38, 47, 50, 0.48);
                    border-radius: 7px;
                    background: rgba(238, 240, 240, 0.2);
                    font-size: 13px;
                  }

                  .info span {
                    min-width: 72px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 650px) {
    .sectionTanque {
      .containerInferior {
        padding: 16px 0 24px;

        > ul {
          display: flex;
          flex-direction: column;
          align-items: center;
          grid-template-columns: minmax(0, 1fr);
          gap: 14px;

          > li {
            max-width: 90%;
            .tanqueTitulo {
              small {
                font-size: 10px;
              }
            }

            .containerInfos {
              width: 100%;
              min-width: 0;
              padding: 44px 14px 16px;

              .conteinerLimite {
                flex-direction: column;
                align-items: stretch;
                gap: 18px;
              }

              .infos {
                margin-right: 38px;

                .barraNivelVerticalWrapper {
                  top: -5px;
                  right: -39px;
                  height: 160px;
                }
              }

              .conteinerStatus {
                align-items: stretch;
                padding-top: 14px;
                padding-left: 0;
                border-top: 1px solid rgba(43, 51, 54, 0.28);
                border-left: 0;
              }
            }
          }
        }
      }
    }
  }
`;

export const CxControle = styled.div`
  /* padding: 15px; */
  width: 30px;
  max-width: 100%;
  height: 25px;
  border-radius: 5px;
  border: 1px solid rgb(0, 0, 0);
  background: ${(props) => props.activo};
`;

const ModalBombaTanqueBase = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(0, 0, 0 0.3);
  backdrop-filter: blur(10px);
  position: fixed;
  z-index: 9;
  top: 0;
  left: 0;
  box-shadow: 1px 2px 31px 0px rgba(255, 255, 255, 0.41);
  -webkit-box-shadow: 1px 2px 31px 0px rgba(255, 255, 255, 0.41);
  -moz-box-shadow: 1px 2px 31px 0px rgba(255, 255, 255, 0.41);
  padding-right: 50px;
  .confimation {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    max-height: 100%;
    background-color: rgba(18, 18, 20, 0.3);
    z-index: 50;
    .ConfirmationChanges {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 600px;
      max-width: 80%;
      background-color: rgba(18, 18, 20, 0.9);
      border: 2px solid #b2b2b2;
      padding: 20px;
      border-radius: 15px;
      gap: 15px;
      h2 {
        color: white;
        text-align: center;
      }
      div {
        display: flex;
        gap: 15px;
        width: 100%;
        button {
          width: 100%;
          height: 50px;
          font-size: 1rem;
          font-family: 'Inter', sans-serif;
          color: #ffffff;
          border: none;
          background-color: rgba(195, 13, 26, 1);
          border-radius: 8px;
          cursor: pointer;
        }
        .buttonYes {
          background-color: transparent;
          color: rgba(1, 255, 24, 1);
          border: 2px solid rgba(1, 255, 24, 1);
          transition: 1s;
        }
        .buttonYes:hover {
          background-color: rgba(5, 164, 21, 1);
          color: white;
        }
      }
    }
  }
  .conteiner {
    display: flex;
    flex-direction: column;
    width: 92%;
    height: 85%;
    background-color: rgba(143, 143, 143, 0.94);
    border-radius: 5px;
    border: 2px solid rgb(62, 62, 62);
    position: relative;
    padding: 18px;
    gap: 25px;
    overflow: auto;
    h3 {
      font-size: 25px;
      color: rgba(47, 47, 47, 1);
    }
    .creatNivel {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      cursor: pointer;
      position: absolute;
      left: 40%;
      .icon {
        font-size: 25px;
        color: rgba(46, 46, 46, 1);
        transition: 0.5s;
      }
      .icon:hover {
        color: rgba(0, 0, 0, 1);
      }
    }
    .closeModal {
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 35px;
      color: rgba(64, 64, 64, 1);
      cursor: pointer;
      transition: 0.5s;
    }
    .closeModal:hover {
      color: black;
    }
    ul {
      list-style: none;
      display: flex;
      gap: 25px;
      flex-wrap: wrap;
      li {
        width: 200px;
        display: flex;
        flex-direction: column;
        gap: 15px;
        width: 350px;
        min-height: 40px;
        max-width: 100%;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 10px;
        box-shadow: 0 0px 30px 0 rgba(232, 232, 232, 0.2);
        padding: 15px;
        color: rgba(203, 203, 203, 1);
        padding-top: 50px;
        position: relative;
        .deleteBomba {
          position: absolute;
          top: 5px;
          right: 15px;
          font-size: 29px;
          cursor: pointer;
          transition: 0.5s;
        }
        .deleteBomba:hover {
          color: rgba(216, 84, 84, 0.8);
        }
        .IdBomba {
          position: absolute;
          font-size: 17px;
          font-weight: 600;
          top: 10px;
          left: 35%;
          color: rgba(239, 239, 239, 1);
        }
        .headerLi {
          position: absolute;
          top: 20px;
          left: 38%;
          font-size: 18px;
          font-weight: 600;
        }

        .buttons {
          display: flex;
          gap: 5px;

          button {
            height: 40px;
            width: 100%;
            background: rgba(0, 0, 0, 0.2);
            border: 2px solid rgba(203, 203, 203, 0.3);
            color: rgba(203, 203, 203, 1);
            border-radius: 5px;
            cursor: pointer;
            transition: 0.8s;
          }
          .off {
            opacity: 50%;
            cursor: no-drop;
          }
          button:hover {
            background: rgba(0, 0, 0, 0.4);
            color: rgba(255, 255, 255, 1);
            border: 2px solid rgba(255, 255, 255, 1);
          }
        }
        .infosPivo {
          display: flex;
          flex-direction: column;
          gap: 20px;
          position: relative;
          height: 47px;
          p {
            font-weight: 600;
          }
          label {
            font-weight: 600;
            color: rgba(207, 207, 207, 1);
            background: linear-gradient(to top, rgba(29, 29, 29, 0.95) 50%, transparent 50%);
            max-width: max-content;
            padding: 0px 4px;
            position: absolute;
            top: -11px;
            left: 15px;
            /* text-shadow: -1px -2px 8px rgba(255, 255, 255, 0.8); */
          }
          input {
            padding: 15px 20px;
            border-radius: 15px;
            border: 1px solid black;
            background-color: rgba(29, 29, 29, 0.95);
            box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
            -webkit-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
            -moz-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
            color: rgba(216, 216, 216, 1);
          }
        }
      }
    }
  }
`;

export const ModalBombaTanque = styled(ModalBombaTanqueBase)`
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 0;
  width: 100vw;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 24px;
  box-sizing: border-box;
  overflow: hidden;
  background: rgba(13, 29, 36, 0.74);
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  box-shadow: none;
  z-index: 9998;

  .conteiner {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 18px 20px;
    width: min(1180px, 100%);
    height: auto;
    max-height: calc(100dvh - 48px);
    box-sizing: border-box;
    padding: 26px;
    overflow: hidden;
    border: 1px solid rgba(88, 117, 129, 0.24);
    border-top: 4px solid #557d8d;
    border-radius: 16px;
    background: #f7f9fa;
    box-shadow: 0 24px 65px rgba(4, 18, 24, 0.34);

    h3 {
      grid-column: 1;
      margin: 0;
      color: #1b3039;
      font-size: 27px;
      letter-spacing: -0.4px;
    }

    .creatNivel {
      grid-column: 2;
      position: static;
      justify-self: end;
      margin-right: 48px;
      min-height: 42px;
      box-sizing: border-box;
      padding: 0 16px;
      border: 1px solid #4358ad;
      border-radius: 9px;
      background: #4c5fb7;
      color: white;
      font-size: 14px;
      font-weight: 700;
      box-shadow: 0 7px 18px rgba(42, 56, 119, 0.2);
      transition:
        background 0.2s,
        transform 0.2s,
        box-shadow 0.2s;

      .icon {
        color: white;
        font-size: 21px;
      }

      &:hover {
        background: #5a6dcc;
        box-shadow: 0 9px 22px rgba(42, 56, 119, 0.28);
        transform: translateY(-1px);
      }
    }

    .closeModal {
      top: 16px;
      right: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 38px;
      height: 38px;
      border-radius: 50%;
      background: #e7edef;
      color: #52666e;
      font-size: 29px;
      z-index: 2;

      &:hover {
        background: #d9e3e7;
        color: #1e333c;
      }
    }

    ul {
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      align-items: start;
      gap: 16px;
      max-height: calc(100dvh - 145px);
      margin: 0;
      padding: 4px 7px 4px 0;
      overflow-y: auto;
      scrollbar-color: #91a6af transparent;

      li {
        display: flex;
        flex-direction: column;
        gap: 14px;
        width: auto;
        min-height: 0;
        max-width: none;
        box-sizing: border-box;
        padding: 18px;
        position: relative;
        border: 1px solid #d2dde1;
        border-top: 4px solid #557d8d;
        border-radius: 13px;
        background: white;
        color: #20343d;
        box-shadow: 0 10px 24px rgba(25, 47, 57, 0.12);

        .IdBomba {
          position: static;
          padding: 0 42px 12px 0;
          border-bottom: 1px solid #dbe3e7;
          color: #1f3540;
          font-size: 18px;
          font-weight: 800;
          text-align: left;
        }

        .deleteBomba {
          top: 17px;
          right: 17px;
          padding: 5px;
          border-radius: 7px;
          color: #74858c;
          font-size: 24px;

          &:hover {
            background: #fbe9e9;
            color: #b84343;
          }
        }

        .infosPivo {
          height: auto;
          gap: 6px;

          label {
            position: static;
            padding: 0;
            background: none;
            color: #435861;
            font-size: 13px;
            font-weight: 700;
          }

          input,
          select {
            width: 100%;
            height: 42px;
            box-sizing: border-box;
            padding: 0 12px;
            border: 1px solid #c6d2d8;
            border-radius: 8px;
            outline: none;
            background: white;
            box-shadow: none;
            color: #22343c;
            font-family: inherit;
            font-size: 14px;
            transition:
              border-color 0.2s,
              box-shadow 0.2s;

            &:focus {
              border-color: #587aaf;
              box-shadow: 0 0 0 3px rgba(88, 122, 175, 0.14);
            }

            &:disabled {
              background: #edf1f3;
              color: #6d7d84;
              cursor: not-allowed;
            }
          }
        }

        .buttons {
          gap: 9px;

          button {
            height: 38px;
            border: 1px solid #9eb0b8;
            border-radius: 8px;
            background: #f6f8f9;
            color: #31464f;
            font-family: inherit;
            font-weight: 700;
            transition:
              background 0.2s,
              border-color 0.2s;
          }

          button:hover:not(:disabled) {
            border-color: #617f8c;
            background: #e5edef;
            color: #223840;
          }

          button:first-child:not(:disabled) {
            border-color: #4c5fb7;
            background: #4c5fb7;
            color: white;
          }

          button:first-child:hover:not(:disabled) {
            border-color: #4355a7;
            background: #4355a7;
            color: white;
          }

          button:disabled,
          .off {
            opacity: 0.45;
            cursor: not-allowed;
          }
        }
      }
    }
  }

  .confimation {
    width: 100vw;
    min-height: 100vh;
    min-height: 100dvh;
    padding: 16px;
    box-sizing: border-box;
    background: rgba(13, 29, 36, 0.72);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    z-index: 10000;

    .ConfirmationChanges {
      width: 440px;
      max-width: 100%;
      box-sizing: border-box;
      padding: 25px;
      border: 1px solid rgba(88, 117, 129, 0.24);
      border-top: 4px solid #557d8d;
      border-radius: 14px;
      background: #f7f9fa;
      box-shadow: 0 22px 55px rgba(4, 18, 24, 0.32);

      h2 {
        margin: 0;
        color: #1d323b;
        font-size: 21px;
      }

      div {
        button {
          height: 42px;
          border: 1px solid #c45252;
          background: #c45252;
          color: white;
          font-family: inherit;
          font-weight: 700;
        }

        .buttonYes {
          border: 1px solid #4c5fb7;
          background: #4c5fb7;
          color: white;
        }

        .buttonYes:hover {
          background: #4355a7;
        }
      }
    }
  }

  @media (max-width: 650px) {
    padding: 10px;

    .conteiner {
      grid-template-columns: minmax(0, 1fr);
      gap: 14px;
      max-height: calc(100dvh - 20px);
      padding: 20px 14px 14px;

      h3,
      .creatNivel,
      ul {
        grid-column: 1;
      }

      h3 {
        padding-right: 44px;
        font-size: 23px;
      }

      .creatNivel {
        justify-self: stretch;
        margin-right: 44px;
      }

      ul {
        grid-template-columns: minmax(0, 1fr);
        max-height: calc(100dvh - 150px);
        padding-right: 3px;
      }
    }
  }
`;
